import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useIsAuthenticated, useIsImpersonationMode } from 'mf_core/auth';
import { usePaymentCards } from './use-paymentCards';
import { useCMPCardCheck } from './useCMPCardCheck';

export function useCMPCardRedirect() {
  const navigate = useNavigate();
  const ignoreCCRedirect = sessionStorage.getItem('ignoreCCRedirect');

  const isAuthenticated = useIsAuthenticated();
  const isImpersonationMode = useIsImpersonationMode();

  const {
    enableCybersource,
    enableDocData,
    enableForcePopupCybersource,
    enableForcePopupDocdata,
    enableForcePopupWorldPay,
    enableWorldPay,
    gateway,
    isFlagLoaded,
  } = useCMPCardCheck();
  const cmpEnabled =
    (enableCybersource && enableForcePopupCybersource) ||
    (enableDocData && enableForcePopupDocdata) ||
    (enableWorldPay && enableForcePopupWorldPay);

  const { data: paymentCards, isFetched: fetchedCards } = usePaymentCards(
    cmpEnabled,
    gateway
  );

  useEffect(() => {
    //Impersonation mode: Card redirect could be skipped
    if (isImpersonationMode) return;

    if (!cmpEnabled) return;

    if (ignoreCCRedirect) return;

    if (isAuthenticated && cmpEnabled && fetchedCards) {
      if (!paymentCards || paymentCards?.length <= 0) {
        localStorage.setItem('forceCCEntry', 'true');
        navigate('/my/account/accountsettings');
      } else if (
        !paymentCards.some((card: any) => card.defaultCard || card.is_default)
      ) {
        localStorage.setItem('forceCCDefault', 'true');
        navigate('/my/account/accountsettings');
      }
    } else {
      localStorage.removeItem('forceCCEntry');
      localStorage.removeItem('forceCCDefault');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cmpEnabled,
    fetchedCards,
    ignoreCCRedirect,
    isAuthenticated,
    isFlagLoaded,
    isImpersonationMode,
    navigate,
    paymentCards?.length,
  ]);
}
